/**
 * Photo category labels — shared across the tech capture flow (PhotoMetaSheet),
 * the deal install report / timeline, and the jobs list so the before/after/etc
 * tag a tech assigns at capture stays visible everywhere the photo is shown.
 */

import type { JobPhoto } from '@/types/schema';

export type PhotoCategory = NonNullable<JobPhoto['category']>;

export const PHOTO_CATEGORY_LABELS: Record<PhotoCategory, string> = {
  before: 'Before',
  after: 'After',
  progress: 'Progress',
  site: 'Site',
  equipment: 'Equipment',
  issue: 'Issue',
  dish_location: 'Dish location',
  router_location: 'Router location',
};

/** Resolve a display label for a photo category. Returns null for empty/unknown. */
export function photoCategoryLabel(category?: string | null): string | null {
  if (!category) return null;
  return PHOTO_CATEGORY_LABELS[category as PhotoCategory] || category;
}
